var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TEAM_CACHE_ENABLED, } from '@lucidlink/sdk';
import { isBitValueFalse, translate, useToastService } from '@lucidlink/uicore';
import { extractFilespaceSettings, } from '@lucidlink/workspacemanagement';
import { FilespaceSettingsKeyFactory } from '../query-key-factories';
import { useSetGlobalSettings } from './useSetGlobalSettings';
export const useSetGlobalTeamCache = (mutationProps, handlers) => {
    _react_refresh_temp_1();
    const { filespaceId, setting, workspaceId } = mutationProps;
    const queryClient = useQueryClient();
    const { mutation: { mutate: setGlobalSettingsMutation }, } = useSetGlobalSettings({ filespaceId, setting, workspaceId }, handlers);
    const { addToast } = useToastService();
    const mutation = useMutation({
        mutationFn: async (settings) => {
            await queryClient.refetchQueries({
                exact: true,
                queryKey: FilespaceSettingsKeyFactory.global(filespaceId),
            });
            const freshGlobalSettingsData = queryClient.getQueryData(FilespaceSettingsKeyFactory.global(filespaceId));
            const globalSettings = extractFilespaceSettings(freshGlobalSettingsData);
            const teamCacheEnabled = globalSettings && globalSettings[TEAM_CACHE_ENABLED];
            if (isBitValueFalse(teamCacheEnabled?.value ?? '')) {
                throw new Error(translate('TeamCache has been disabled for your workspace. Contact your admin for more info'));
            }
            setGlobalSettingsMutation(settings);
        },
        onError(error) {
            addToast({
                'data-testid': 'set-team-cache-error',
                kind: 'negative',
                content: {
                    message: error.message,
                },
            });
        },
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useSetGlobalTeamCache, "00PzmuKtXpaGLNl/aaBLswL0tPA=", false, () => [useQueryClient, useSetGlobalSettings, useToastService, useMutation]);
